import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react"

export const bannerApi = createApi({
    reducerPath : "bannerApi",
    baseQuery : fetchBaseQuery({baseUrl:"/api"}),
    
    //creating our endpoints through builder ==> query/mutation
    endpoints : (builder) =>({
        getBanners : builder.query({
            
            // query : (params)=>({
            //     url :"/banners",
            // })
                //params = it may contains qury /fileter/search string to query from banner dbf
            query : (params)=>  "/banners",
        


        })
    })
    
    
})

export const {useGetBannersQuery} = bannerApi;
